export enum PaymentOrderType {
Normal,
Deductions,
Prepayment,
}
